import { render, staticRenderFns } from "./ActivityMessage.vue?vue&type=template&id=104f5c7e&scoped=true&"
import script from "./ActivityMessage.vue?vue&type=script&lang=js&"
export * from "./ActivityMessage.vue?vue&type=script&lang=js&"
import style0 from "./ActivityMessage.vue?vue&type=style&index=0&id=104f5c7e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104f5c7e",
  null
  
)

export default component.exports